import { render } from "./FormCavityWallDefectsView.vue?vue&type=template&id=d1dbd2a0"
import script from "./FormCavityWallDefectsView.vue?vue&type=script&lang=js"
export * from "./FormCavityWallDefectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__